import { useEffect } from "react";

export default function Beta() {
    useEffect(() => {
        function timer() {
            const finalDate = new Date("2023-01-01").getTime();
            const monthsSpan = document.getElementById("ss-months");
            const daysSpan = document.getElementById('ss-days');
            const hoursSpan = document.getElementById('ss-hours');
            const minutesSpan = document.getElementById('ss-minutes');
            const secondsSpan = document.getElementById('ss-seconds');
            if ((daysSpan && hoursSpan && minutesSpan && secondsSpan)) {
                const now = new Date().getTime();
                let diff = finalDate - now;
                if (diff <= 0) {
                    return;
                }
                let months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
                let days = Math.floor((diff / (1000 * 60 * 60 * 24)) % 30);
                let hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                let minutes = Math.floor((diff / 1000 / 60) % 60);
                let seconds = Math.floor((diff / 1000) % 60);
                if (months <= 9) months = "0" + months;
                if (days <= 9) days = "0" + days;
                if (hours <= 9) hours = '0' + hours
                if (minutes <= 9) minutes = '0' + minutes
                if (seconds <= 9) seconds = '0' + seconds

                monthsSpan.textContent = months;
                daysSpan.textContent = days;
                hoursSpan.textContent = hours;
                minutesSpan.textContent = minutes;
                secondsSpan.textContent = seconds;
            }
        }
        timer();
        setInterval(timer, 1000);
    }, [])

    return (
        <>
            <main className=" min-h-screen flex items-center justify-center sm:px-5 sm:py-5 bg-blue-500">
                <title>Disconomy Geliştiriliyor</title>
                <div className="max-w-screen-xl rounded-3xl overflow-auto text-gray-300 w-full font-extrabold">
                    <div className="md:flex flex-col w-full">
                        <div className="items-center justify-center space-x-2 sm:space-x-10 flex flex-wrap">
                            <div className="align-top flex">
                                <span id="ss-months" className="text-[4rem] sm:text-[7rem] font-semibold tracking-tight">00</span>
                                <span className="text-xl sm:text-2xl text-gray-300 mt-11 opacity-30"> Ay</span>
                            </div>
                            <div className="align-top flex">
                                <span id="ss-days" className="text-[4rem] sm:text-[7rem] font-semibold tracking-tight">00</span>
                                <span className="text-xl sm:text-2xl text-gray-300 mt-11 opacity-30"> Gün</span>
                            </div>
                            <div className="align-top flex">
                                <span id="ss-hours" className="text-[4rem] sm:text-[7rem] font-semibold tracking-tight">00</span>
                                <span className="text-xl sm:text-2xl text-gray-300 mt-11 opacity-30"> Saat</span>
                            </div>
                            <div className="align-top flex">
                                <span id="ss-minutes" className="text-[4rem] sm:text-[7rem] font-semibold tracking-tight">00</span>
                                <span className="text-xl sm:text-2xl text-gray-300 mt-11 opacity-30"> Dakika</span>
                            </div>
                            <div className="align-top flex">
                                <span id="ss-seconds" className="text-[4rem] sm:text-[7rem] font-semibold tracking-tight">00</span>
                                <span className="text-xl sm:text-2xl text-gray-300 mt-11 opacity-30"> Saniye</span>
                            </div>
                        </div>
                        <div className="w-full py-10 px-5 md:px-10 ">
                            <h1 className="text-3xl sm:text-5xl font-semibold text-center text-gray-300">
                                Disconomy geliştirilme aşamasındadır.
                            </h1>
                        </div>
                    </div>
                </div>
            </main>
            <div className="area overflow-hidden" >
                <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div >

        </>
    )
}